import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, BadgeJapaneseYen } from 'lucide-react';
import { Button } from '../components/ui/button';
import { useLanguage } from '../context/LanguageContext';
import { useLogo } from '../context/LogoContext';
import LanguageSelector from '../components/LanguageSelector';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function PricingPage() {
  const { t, language } = useLanguage();
  const { logoUrl } = useLogo();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API_URL}/api/public/pricing?lang=${language}`).then(res => setData(res.data)).catch(() => {}).finally(() => setLoading(false));
  }, [language]);

  return (
    <div className="min-h-screen bg-background">
      <header className="border-b border-border/50 bg-white/80 backdrop-blur-md sticky top-0 z-50">
        <div className="max-w-4xl mx-auto px-4 md:px-8 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center gap-2"><img src={logoUrl} alt="PRC Remit" className="h-9 w-9 rounded-full object-cover" /><span className="font-logo text-2xl font-bold text-primary">PRC Remit</span></Link>
            <div className="flex items-center gap-3">
              <LanguageSelector />
              <Link to="/"><Button variant="ghost" size="sm" className="gap-2"><ArrowLeft className="h-4 w-4" />{t('company_back')}</Button></Link>
            </div>
          </div>
        </div>
      </header>
      <main className="max-w-4xl mx-auto px-4 md:px-8 py-12 md:py-16" data-testid="pricing-page">
        {loading ? (
          <div className="text-center py-12 text-muted-foreground">{t('loading')}</div>
        ) : !data?.content ? (
          <div className="text-center py-16 bg-card border border-border/50 rounded-2xl">
            <BadgeJapaneseYen className="h-16 w-16 text-muted-foreground mx-auto mb-4 opacity-30" />
            <p className="text-muted-foreground">{t('legal_no_data')}</p>
          </div>
        ) : (
          <div className="bg-card border border-border/50 rounded-2xl p-8 md:p-12">
            <h1 className="font-heading text-3xl md:text-4xl font-bold text-primary mb-3">{data.title || t('pricing_page_title')}</h1>
            {data.last_revised && <p className="text-sm text-muted-foreground mb-8">{t('legal_last_revised')}: {data.last_revised}</p>}
            <div className="text-muted-foreground leading-relaxed whitespace-pre-wrap">{data.content}</div>
          </div>
        )}
      </main>
      <footer className="border-t border-border bg-secondary/30 py-8 mt-12"><div className="max-w-4xl mx-auto px-4 md:px-8 text-center text-sm text-muted-foreground"><p>&copy; 2026 PRC Remit. All rights reserved.</p></div></footer>
    </div>
  );
}
